module.exports = __webpack_public_path__ + "img/iphone@2x.b4863335.png";